import { useGLTF, RoundedBox } from "@react-three/drei";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import { useMemo } from "react";
import { COLORS } from "../../constants/colors";
import TreeShadow from "./TreeShadow.jsx";
import { MODELS } from "../loader/models.js";

const MiniTreeRed = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  const tree = useGLTF(MODELS.MINI_TREE_RED);

  // Клонируем сцену для каждого экземпляра
  const clonedScene = useMemo(() => {
    return tree.scene.clone();
  }, [tree.scene]);

  return (
    <group position={position} rotation={rotation}>
      <TreeShadow size={2.5} opacity={0.35} softness={0.8} />
      <primitive scale={0.7} position-y={-1} object={clonedScene} />
      <RigidBody type="fixed" ccd={false}>
        <CuboidCollider args={[0.5, 0.25, 0.5]} />
        <RoundedBox args={[0.7, 0.2, 0.7]} position-y={-1} radius={0.05}>
          <meshStandardMaterial color={COLORS.wood} />
        </RoundedBox>
      </RigidBody>
    </group>
  );
};

export default MiniTreeRed;
